<script lang="ts">
    import SocialChatInput from "./SocialChatInput.svelte";
    import SocialChat from "./SocialChat.svelte";
    export let socialItem
</script>
<div class="timeline-content">
    <p>{socialItem.discription}</p>
    <div class="like-content">
        <span>
            <i class="fa fa-heart font-danger"></i>
        </span>
        <span class="pull-right comment-number">
            <span>20 </span>
            <span>
                <i class="fa fa-share-alt me-0"></i>
            </span>
        </span>
        <span class="pull-right comment-number">
            <span>10 </span>
            <span>
                <i class="fa fa-comments-o"></i>
            </span>
        </span>
    </div>
    <SocialChat socialItem={socialItem}/>
    <SocialChatInput />
</div>